import React from "react";
import {
    Switch,
    FormGroup,
    FormControlLabel
} from "@mui/material";
import {useTheme} from "../../../contexts/theme";

interface StyledSwitchProps {
    checked: boolean;
    label: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const StyledCheckBox: React.FC<StyledSwitchProps> = ({onChange, checked, label}) => {

    const theme = useTheme();

    return (
        <FormGroup>
            <FormControlLabel
                control={<Switch sx={{
                    '& .MuiSwitch-thumb': {
                        backgroundColor: theme.palette.lightGrey,  // Color of the thumb (circle)
                    },
                    '& .MuiSwitch-track': {
                        backgroundColor: theme.palette.lightGrey,  // Color of the track (background bar)
                    },
                    '& .Mui-checked .MuiSwitch-thumb': {
                        backgroundColor: theme.palette.orange,  // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.orange, // Track color when checked
                    }
                }} checked={checked} onChange={onChange}/>} label={label} sx={{color: theme.palette.white, fontWeight: theme.fontWeights.title, fontSize: theme.fontSizes.subParagraphTitle}}/>
        </FormGroup>
    );
};

export default StyledCheckBox;